import React, { useState, useContext, useEffect } from 'react';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';


// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import ClientService from '../../services/ClientService';

// local imports
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';


const ClientSignUpStep3 = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState();
    const [client, setClient] = useState({});
    const [requirementsList, setRequirementsList] = useState([false, false, false, false, false]);

    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (message && message.msgError) {
            window.scrollTo(0, 0);
        }
    }, [message]);

    useEffect(() => {
        try {
            if (props.location.state) {
                setClient(props.location.state.client);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (requirementsList[0]) {
                setIsLoading(true);
                ClientService.signup(client)
                    .then(data => {
                        setUser({ ...user, selectedRole: data.user.selectedRole, roles: data.user.roles, username: data.user.username, profileImage: data.user.profileImage });
                        Alert.info(data.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        props.history.push('/client/dashboard');
                        setIsLoading(false);
                    })
                    .catch(error => {
                        Alert.error(error.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        setIsLoading(false);
                    });
            } else {
                setMessage({ msgError: true, msgBody: "You must agree to terms and policy" });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // setIsLoading2(false);
            // GeneralService.logError('at Client ClientProfile handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />

            <h1 id="client-signup-heading" className='mt-5 pl-4' style={theme.headingMedium}>Client Signup</h1>

            <div className='mt-5 mb-5 row'>

                <div className='col-md-3 col-12' style={{ borderRight: "solid 1px", borderColor: "#C0C0C0" }}>
                    <ol>
                        <li id="client-signup-fill-info" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm }}>Fill in your Information</li>
                        <li id="client-signup-reviewandsubmit" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm, fontWeight: fontWeight.semiBold }}>Review and Submit</li>
                    </ol>
                </div>

                <div className='col-md-9 col-12'>
                    <h2 id="review-submit" style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md, fontWeight: fontWeight.semiBold }}>Review and Submit</h2>
                    <hr style={{ color: "#C0C0C0", borderWidth: "2px" }} />

                    {message ? <div className='mt-5'><Message message={message} /></div> : null}

                    <div className='mt-5'>
                        <h3 style={{ fontFamily: fontFamily.primary, fontSize: fontSize.lg, fontWeight: fontWeight.medium }}>Your Information</h3>

                        <table className='mt-3' style={{ width: "500px", fontFamily: fontFamily.primary }}>

                            <colgroup>
                                <col span="1" style={{ width: "50%" }} />
                                <col span="1" style={{ width: "50%" }} />
                            </colgroup>

                            <tbody>

                                <tr>
                                    <td id="client-title" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Title
                                    </td>
                                    <td id="client-title-value">
                                        {client.title}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-first-name" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        First Name
                                    </td>
                                    <td id="client-first-name-value">
                                        {client.firstName}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-last-name" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Last Name
                                    </td>
                                    <td id="client-last-name-value">
                                        {client.lastName}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-email" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Email
                                    </td>
                                    <td id="client-email-value">
                                        {client.email}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-gender" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Gender
                                    </td>
                                    <td id="client-gender-value">
                                        {client.gender}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-addres-1" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Address line 1
                                    </td>
                                    <td id="client-addres-1-value">
                                        {client.address1}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-address-2" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Address line 2
                                    </td>
                                    <td id="client-address-2-value">
                                        {client.address2}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-city" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        City
                                    </td>
                                    <td id="client-city-value">
                                        {client.city}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-state" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        State
                                    </td>
                                    <td id="client-state-value">
                                        {client.state}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-pincode" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Pincode
                                    </td>
                                    <td id="client-pincode-value">
                                        {client.pincode}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="client-country" style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                        Country
                                    </td>
                                    <td id="client-country-value">
                                        {client.country}
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>


                    <div className='mt-5'>
                        <div className="form-check mb-3">
                            <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[0]} id="cb5" onChange={(e) => setRequirementsList({ ...requirementsList, 0: e.target.checked })} />
                            <label id="client-agreemenet" className="form-check-label ml-2" htmlFor="cb5" style={{ cursor: "pointer" }}> I agree to all <Link to='/termsconditions'><u>Terms &#38; Conditions</u></Link>, <Link to='/privacypolicy'><u>Privacy Policy</u></Link> and <Link to='/cookiepolicy'><u>Cookie Policy</u></Link> of Umang Wellness.</label>
                        </div>
                    </div>

                    <p id="previouspage" className='mt-5 mb-0 float-left' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={() => props.history.push('/client/signup-step1')}><i className="fas fa-arrow-circle-left"></i> Previous</p>
                    <p id="nextpage" className='mt-5 mb-0 float-right mr-5' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={(e) => handleSubmit(e)}>Submit <i className="fas fa-paper-plane"></i></p>

                </div>

            </div>


            <Footer />

        </div>
    )
}

export default ClientSignUpStep3;